import Data from './Data';

const SubjectSidebar = (props) => {
  return <Data {...props} />;
};

export default SubjectSidebar;
